import {
    createLoadingSpinner,
    LoadingSpinner,
    LOADING_SPINNER_SIZE_MEDIUM,
} from '@vfde-brix/ws10/loading-spinner';
import { selectLoading } from '../container/App/selectors';
import { startAppListening } from '../container/App/listener';

/**
 * Mount loading spinner
 */
export default function mountLoadingSpinner (id: string): LoadingSpinner | null {
    const container = document.getElementById(id);

    const loadingSpinner = container && createLoadingSpinner(container, {
        optSize: LOADING_SPINNER_SIZE_MEDIUM,
        business: {},
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectLoading(currentState) !== selectLoading(previousState),
        effect: (_action, api) => {
            api.cancelActiveListeners();

            const isLoading = selectLoading(api.getState());

            loadingSpinner?.toggle(isLoading);
        },
    });

    return loadingSpinner;
}
